import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import axios from "../../api/axios";

const Login = () => {
  const [formData, setFormData] = useState({ usuario: "", contraseña: "" });
  const [errores, setErrores] = useState({});
  const [mensajeError, setMensajeError] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth(); // Hook para actualizar el contexto

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const validarCampos = () => {
    const nuevosErrores = {};
    const correoRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.usuario.trim()) {
      nuevosErrores.usuario = "El usuario es obligatorio";
    } else if (!correoRegex.test(formData.usuario)) {
      nuevosErrores.usuario = "Debe ser un correo electrónico válido";
    }

    if (!formData.contraseña.trim()) {
      nuevosErrores.contraseña = "La contraseña es obligatoria";
    }

    return nuevosErrores;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const erroresValidados = validarCampos();
    if (Object.keys(erroresValidados).length > 0) {
      setErrores(erroresValidados);
      setMensajeError("");
      return;
    }

    setErrores({});
    setMensajeError("");

    try {
      const response = await axios.post("/api/login", formData, {
        withCredentials: true, // Para enviar cookies
      });

      const userData = response.data;
      login(userData); // Actualiza el contexto y localStorage

      // Navegación segura según rol
      if (userData.role === "admin") {
        navigate("/", { replace: true });
      } else if (userData.role === "user") {
        navigate("/users", { replace: true });
      } else if (userData.role === "oper") {
        navigate("/oper", { replace: true });
      } else if (userData.role === "tec") {
        navigate("/tec", { replace: true });
      } else {
        navigate("/login", { replace: true }); // fallback
      }
    } catch (error) {
      setMensajeError(
        error.response?.data?.message || "Error de conexión con el servidor."
      );
    }

    return (
      <div>
        <h2>Iniciar sesión</h2>
        <form onSubmit={handleSubmit}>
          <input
            id="usuario"
            type="email"
            placeholder="Correo"
            value={formData.usuario}
            onChange={handleChange}
          />
          {errores.usuario && <p>{errores.usuario}</p>}

          <input
            id="contraseña"
            type="password"
            placeholder="Contraseña"
            value={formData.contraseña}
            onChange={handleChange}
          />
          {errores.contraseña && <p>{errores.contraseña}</p>}

          <button type="submit">Entrar</button>
        </form>
        {mensajeError && <p>{mensajeError}</p>}
      </div>
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-100">
      <form
        onSubmit={handleSubmit}
        className="bg-secondary-900 p-8 rounded-xl shadow-lg w-full max-w-sm text-white"
      >
        <h2 className="text-2xl font-bold mb-6 text-center uppercase">
          Iniciar Sesión
        </h2>

        {mensajeError && (
          <div className="bg-red-500 text-white text-sm p-2 rounded mb-4 text-center">
            {mensajeError}
          </div>
        )}

        <div className="mb-4">
          <label htmlFor="usuario" className="block mb-1 text-sm font-semibold">
            Correo electrónico
          </label>
          <input
            id="usuario"
            type="text"
            value={formData.usuario}
            onChange={handleChange}
            placeholder="ejemplo@correo.com"
            className="w-full p-2 rounded-lg bg-secondary-200 text-white"
          />
          {errores.usuario && (
            <p className="text-red-500 text-xs mt-1">{errores.usuario}</p>
          )}
        </div>

        <div className="mb-6">
          <label
            htmlFor="contraseña"
            className="block mb-1 text-sm font-semibold"
          >
            Contraseña
          </label>
          <input
            id="contraseña"
            type="password"
            value={formData.contraseña}
            onChange={handleChange}
            placeholder="Ingresa tu contraseña"
            className="w-full p-2 rounded-lg bg-secondary-200 text-white"
          />
          {errores.contraseña && (
            <p className="text-red-500 text-xs mt-1">{errores.contraseña}</p>
          )}
        </div>

        <button
          type="submit"
          className="w-full bg-secondary-100 py-2 rounded-lg font-bold uppercase hover:bg-primary-dark transition-colors"
        >
          Entrar
        </button>
      </form>
    </div>
  );
};

export default Login;
